/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbServiceTutelleLocaliteGridDto } from './FcbServiceTutelleLocaliteGridDto';
import {
    FcbServiceTutelleLocaliteGridDtoFromJSON,
    FcbServiceTutelleLocaliteGridDtoFromJSONTyped,
    FcbServiceTutelleLocaliteGridDtoToJSON,
} from './FcbServiceTutelleLocaliteGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbServiceTutelleLocaliteGridDtoPaginatedResults
 */
export interface FcbServiceTutelleLocaliteGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleLocaliteGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbServiceTutelleLocaliteGridDto>}
     * @memberof FcbServiceTutelleLocaliteGridDtoPaginatedResults
     */
    results?: Array<FcbServiceTutelleLocaliteGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbServiceTutelleLocaliteGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbServiceTutelleLocaliteGridDtoPaginatedResults interface.
 */
export function instanceOfFcbServiceTutelleLocaliteGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbServiceTutelleLocaliteGridDtoPaginatedResultsFromJSON(json: any): FcbServiceTutelleLocaliteGridDtoPaginatedResults {
    return FcbServiceTutelleLocaliteGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbServiceTutelleLocaliteGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbServiceTutelleLocaliteGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbServiceTutelleLocaliteGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbServiceTutelleLocaliteGridDtoPaginatedResultsToJSON(value?: FcbServiceTutelleLocaliteGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbServiceTutelleLocaliteGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

